import React from 'react';

interface B2BParticipantAvatarSectionProps {
  profilePhoto?: string | null;
  onAvatarChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const B2BParticipantAvatarSection: React.FC<B2BParticipantAvatarSectionProps> = ({
  profilePhoto,
  onAvatarChange
}) => {
  return (
    // <div className="avatar-section">
    //   <div className="avatar-container">
    //     {profilePhoto && !imageError ? (
    //       <img
    //         src={profilePhoto}
    //         alt="Profile"
    //         className="avatar-image"
    //         onError={() => setImageError(true)}
    //       />
    //     ) : (
    //       <div className="avatar-placeholder">
    //         <span>No Image</span>
    //       </div>
    //     )}
    //     <input
    //       type="file"
    //       accept="image/*"
    //       onChange={onAvatarChange}
    //       className="avatar-upload"
    //       id="avatar-upload"
    //     />
    //     <label htmlFor="avatar-upload" className="avatar-upload-label">
    //       Change Photo
    //     </label>
    //   </div>
    // </div>
    null
  );
};

export default B2BParticipantAvatarSection;
